import React, { useEffect } from "react";

export const SeoOptimizer: React.FC = () => {
	useEffect(() => {
		// Set title
		document.title = "JobMap.work | AI Job Application Assistant and Tracker";

		// Set meta description
		let metaDescription = document.querySelector('meta[name="description"]');
		if (!metaDescription) {
			metaDescription = document.createElement("meta");
			metaDescription.setAttribute("name", "description");
			document.head.appendChild(metaDescription);
		}
		metaDescription.setAttribute(
			"content",
			"Track job applications so you never lose one; create the perfect cover letter and resume each time with ATS-optimized AI tools; and, get hired faster."
		);

		// Set meta keywords
		let metaKeywords = document.querySelector('meta[name="keywords"]');
		if (!metaKeywords) {
			metaKeywords = document.createElement("meta");
			metaKeywords.setAttribute("name", "keywords");
			document.head.appendChild(metaKeywords);
		}
		metaKeywords.setAttribute(
			"content",
			"job application tracker, resume analysis, cover letter generator, ATS optimization, job search tools"
		);

		// Get current URL
		const currentUrl = window.location.origin + window.location.pathname;

		// Set canonical tag
		let canonical = document.querySelector('link[rel="canonical"]');
		if (!canonical) {
			canonical = document.createElement("link");
			canonical.setAttribute("rel", "canonical");
			document.head.appendChild(canonical);
		}
		canonical.setAttribute("href", currentUrl);

		// Remove any existing hreflang tags
		const existingHreflangs = document.querySelectorAll(
			'link[rel="alternate"][hreflang]'
		);
		existingHreflangs.forEach((tag) => tag.remove());

		// Add x-default hreflang
		const hreflangDefault = document.createElement("link");
		hreflangDefault.setAttribute("rel", "alternate");
		hreflangDefault.setAttribute("hreflang", "x-default");
		hreflangDefault.setAttribute("href", currentUrl);
		document.head.appendChild(hreflangDefault);

		// Add en-US hreflang
		const hreflangEnUS = document.createElement("link");
		hreflangEnUS.setAttribute("rel", "alternate");
		hreflangEnUS.setAttribute("hreflang", "en-US");
		hreflangEnUS.setAttribute("href", currentUrl);
		document.head.appendChild(hreflangEnUS);

		// Add en hreflang
		const hreflangEn = document.createElement("link");
		hreflangEn.setAttribute("rel", "alternate");
		hreflangEn.setAttribute("hreflang", "en");
		hreflangEn.setAttribute("href", currentUrl);
		document.head.appendChild(hreflangEn);

		// Add sitemap link
		let sitemapLink = document.querySelector('link[rel="sitemap"]');
		if (!sitemapLink) {
			sitemapLink = document.createElement("link");
			sitemapLink.setAttribute("rel", "sitemap");
			sitemapLink.setAttribute("type", "application/xml");
			document.head.appendChild(sitemapLink);
		}
		sitemapLink.setAttribute("href", `${window.location.origin}/sitemap.xml`);
		sitemapLink.setAttribute("title", "Sitemap");

		// Add Schema.org structured data
		const existingSchema = document.querySelector(
			'script[type="application/ld+json"]'
		);
		if (existingSchema) {
			existingSchema.remove();
		}

		const schemaData = {
			"@context": "https://schema.org",
			"@graph": [
				{
					"@type": "WebSite",
					name: "JobMap.work",
					url: window.location.origin,
					description:
						"Track job applications, create the perfect cover letter and resume with AI, and organize your job search with ATS-optimized tools, to get hired faster.",
					potentialAction: {
						"@type": "SearchAction",
						target: {
							"@type": "EntryPoint",
							urlTemplate: `${window.location.origin}/search?q={search_term_string}`
						},
						"query-input": "required name=search_term_string"
					}
				},
				{
					"@type": "WebApplication",
					name: "JobMap.work",
					applicationCategory: "BusinessApplication",
					operatingSystem: "Web Browser",
					offers: {
						"@type": "Offer",
						price: "0",
						priceCurrency: "USD"
					},
					description:
						"AI-powered job application tracking and resume optimization tool. Create perfect cover letters and resumes, track applications, and get hired faster with ATS-optimized tools.",
					featureList: [
						"Job application tracking",
						"AI-powered resume analysis",
						"Cover letter generator",
						"ATS optimization",
						"Application organization"
					]
				},
				{
					"@type": "Organization",
					name: "JobMap.work",
					url: window.location.origin,
					logo: `${window.location.origin}/MappyIcon_64.png`,
					description:
						"JobMap.work provides AI-powered tools to help job seekers track applications, optimize resumes, and create compelling cover letters.",
					sameAs: []
				}
			]
		};

		const schemaScript = document.createElement("script");
		schemaScript.setAttribute("type", "application/ld+json");
		schemaScript.textContent = JSON.stringify(schemaData);
		document.head.appendChild(schemaScript);
	}, []);

	return null;
};
